import React from 'react'
import { cn } from '@/utils/style.ts'

type BaseLayoutProps = Omit<React.ComponentPropsWithoutRef<'div'>, 'id'>

export const PageLayout: React.FC<BaseLayoutProps> = ({ className, ...props }) => {
  return <div id="base-layout" className={cn('w-full py-4 px-6 box-border', className)} {...props} />
}